<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">
        <template v-if="detail == false">設備商資訊</template>
        <template v-else-if="detail == true">設備商建檔</template>
      </div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="detail == false">
            <basic />
          </template>
          <template v-else-if="detail == true">
            <companyInformation />
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import basic from "@/components/deviceManagement/deviceCompany/basic.vue";
import companyInformation from "@/components/deviceManagement/deviceCompany/companyInformation.vue";
import { computed, provide, ref } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    commonTable,
    basic,
    companyInformation,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const detail = ref(false);
    const firm = ref("");

    const add = ref(false);
    const mod = ref(false);

    const manufacInfoTableFields = ref([
      {
        key: "companyName",
        label: "廠商名稱",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "contactPerson",
        label: "聯絡人",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "telephone",
        label: "電話",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "phone",
        label: "行動電話",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "fax",
        label: "傳真",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "address",
        label: "地址",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mail",
        label: "E-mail",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "note",
        label: "備註",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const manufacInfoTableItems = ref([]);

    const companyInformationTableFields = ref([
      {
        key: "companyName",
        label: "廠商名稱",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "telephone",
        label: "電話",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "fax",
        label: "傳真",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "address",
        label: "地址",
        thStyle: {
          "min-width": "360px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "category",
        label: "類別",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const companyInformationTableItems = ref([]);
    const addCompanyInformationTableItems = ref([
      {
        companyName: "",
        telephone: "",
        fax: "",
        address: "",
        category: "",
      },
    ]);
    const equipmentVendorTableFields = ref([
      {
        key: "contactPerson",
        label: "聯絡人",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "extension",
        label: "分機",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "phone",
        label: "行動電話",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mail",
        label: "E-mail",
        thStyle: {
          "min-width": "240px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "note",
        label: "備註",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const equipmentVendorTableItems = ref([]);
    const addEquipmentVendorTableItems = ref([
      {
        contactPerson: "",
        extension: "",
        phone: "",
        mail: "",
        note: "",
      },
    ]);

    const queryFirmInfo = () => {
      manufacInfoTableItems.value = [];
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryFirmInfo";
      params["firm"] = firm.value;
      console.log(firm.value);
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          manufacInfoTableItems.value = QueryTableData;
          if (QueryTableData.length == 0) {
            methods.setTimeoutAlert("查無資料");
          }
        } else {
          manufacInfoTableItems.value = [];
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };
    const companyRowClick = (itemData) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QuerySelectFirmInfo";
      params["companyName"] = itemData.companyName;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          companyInformationTableItems.value =
            QueryTableData["companyInformation"];
          equipmentVendorTableItems.value = QueryTableData["equipmentVendor"];
          detail.value = true;
          add.value = false;
          mod.value = false;
        } else {
          methods.setTimeoutAlert(response);
          back();
        }
        methods.triggerLoadingBar();
      });
    };

    const addCompany = () => {
      const { ...rest } = addCompanyInformationTableItems.value[0];
      addCompanyInformationTableItems.value[0] = {
        ...Object.fromEntries(Object.keys(rest).map((key) => [key, ""])),
      };

      const firstItem = addEquipmentVendorTableItems.value[0];
      const resetObject = {};
      for (const key in firstItem) {
        resetObject[key] = "";
      }
      addEquipmentVendorTableItems.value = [resetObject];

      detail.value = true;
      add.value = true;
      mod.value = false;
    };

    const addCompanyCheck = () => {
      methods.triggerLoadingBar();
      const companyItem = addCompanyInformationTableItems.value[0];

      //確認物件的每個key都有值
      const checkObjectValues = (object) => {
        for (const key in object) {
          if (key == "fax") {
            continue;
          }
          if (!object[key]) {
            return false; // 如果任何 key 的值為空或未定義，返回 false
          }
        }
        return true; // 如果每個 key 都有值，返回 true
      };

      const allKeysHaveValues = checkObjectValues(companyItem);
      if (!allKeysHaveValues) {
        methods.setTimeoutAlert("設備商資訊未填寫完全");
        methods.triggerLoadingBar();
        return;
      }

      const items = addEquipmentVendorTableItems.value;

      let addContact = [];
      let emptyItemCount = 0;
      for (const item of items) {
        if (item.contactPerson == "") {
          emptyItemCount++;
        } else {
          addContact.push(item);
        }
      }
      if (emptyItemCount === items.length) {
        methods.setTimeoutAlert("請輸入聯絡人");
        methods.triggerLoadingBar();
        return;
      }
      //判斷聯絡人資訊是不是每個欄位都有填
      // const isAllValuesEmpty = (item) => {
      //   return Object.values(item).every((value) => value === "");
      // };

      // let allValuesFilledCount = 0;

      // for (const item of items) {
      //   if (isAllValuesEmpty(item)) {
      //     emptyItemCount++;
      //   } else if (!isAllValuesEmpty(item)) {
      //     if (!Object.values(item).some((value) => value === "")) {
      //       allValuesFilledCount++;
      //       addContact.push(item);
      //     }
      //   }
      // }

      // if (emptyItemCount === items.length) {
      //   methods.setTimeoutAlert("請輸入聯絡人");
      //   methods.triggerLoadingBar();
      //   return;
      // } else if (allValuesFilledCount + emptyItemCount !== items.length) {
      //   methods.setTimeoutAlert("訊息未填寫完全");
      //   methods.triggerLoadingBar();
      //   return;
      // }

      addCompanyInfo(companyItem, addContact);
    };

    //確認新增設備資料
    const addCompanyInfo = (companyItem, addContact) => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "AddCompany";
      params["companyItem"] = companyItem;
      params["addContact"] = addContact;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          add.value = true;
          methods.setTimeoutAlert(result["Response"]);
        } else {
          //儲存新增的類別
          firm.value = addCompanyInformationTableItems.value[0].category;
          //新增後返回
          back();
        }
        methods.triggerLoadingBar();
      });
    };

    const modCompany = () => {
      addCompanyInformationTableItems.value = JSON.parse(
        JSON.stringify(companyInformationTableItems.value)
      );
      addEquipmentVendorTableItems.value = JSON.parse(
        JSON.stringify(equipmentVendorTableItems.value)
      );
      detail.value = true;
      add.value = false;
      mod.value = true;
    };

    const modCompanyCancel = () => {
      detail.value = true;
      add.value = false;
      mod.value = false;
    };
    const modCompanyCheck = () => {
      methods.triggerLoadingBar();
      const firmUpdateData = {};
      const orgValue = companyInformationTableItems.value[0];
      const currentValue = addCompanyInformationTableItems.value[0];
      // 比較兩個物件的不同處
      for (const key in orgValue) {
        if (orgValue.hasOwnProperty(key)) {
          console.log(key);
          if (orgValue[key] !== currentValue[key]) {
            // 儲存不同之處
            firmUpdateData[key] = currentValue[key];
          }
        }
      }

      const contactUpdateData = [];
      const addContact = [];
      const delContact = [];
      for (let i = 0; i < equipmentVendorTableItems.value.length; i++) {
        const orgItem = equipmentVendorTableItems.value[i];
        const currentItem = addEquipmentVendorTableItems.value[i];

        const changedKeys = Object.keys(currentItem).filter(
          (key) => currentItem[key] !== orgItem[key]
        );

        if (changedKeys.length > 0) {
          contactUpdateData.push(currentItem);
          // const changedValues = changedKeys.reduce((result, key) => {
          //   result[key] = currentItem[key];
          //   return result;
          // }, {});

          // contactUpdateData.push({
          //   contactPerson: currentItem.contactPerson,
          //   ...changedValues,
          // });
        }
        if (currentItem["contactPerson"] == "") {
          delContact.push(currentItem);
        }
      }

      if (
        equipmentVendorTableItems.value.length <
        addEquipmentVendorTableItems.value.length
      ) {
        const extraItems = addEquipmentVendorTableItems.value.slice(
          equipmentVendorTableItems.value.length
        );

        for (const item of extraItems) {
          if (item.contactPerson !== "") {
            addContact.push({
              contactPerson: item.contactPerson,
              ...item,
            });
          }
        }
      }
      console.log(firmUpdateData);
      console.log(contactUpdateData);
      console.log(addContact);
      console.log(delContact);
      if (
        Object.keys(firmUpdateData).length === 0 &&
        contactUpdateData.length === 0 &&
        addContact.length === 0 &&
        delContact.length === 0
      ) {
        methods.setTimeoutAlert("無修改項目");
        methods.triggerLoadingBar();
        return;
      }
      modCompanyInfo(
        companyInformationTableItems.value[0]["companyName"],
        firmUpdateData,
        contactUpdateData,
        addContact,
        delContact
      );
      return;
    };

    const modCompanyInfo = (
      companyName,
      firmUpdateData,
      contactUpdateData,
      addContact,
      delContact
    ) => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateCompanyInfo";
      params["firmUpdateData"] = firmUpdateData;
      params["contactUpdateData"] = contactUpdateData;
      params["addContact"] = addContact;
      params["delContact"] = delContact;
      params["companyName"] = companyName;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          companyRowClick({ companyName: companyName });
        }
        methods.triggerLoadingBar();
      });
    };

    const back = () => {
      if (firm.value != "") {
        queryFirmInfo();
      }
      detail.value = false;
      add.value = false;
      mod.value = false;
    };

    const addContactPerson = () => {
      addEquipmentVendorTableItems.value.push({
        contactPerson: "",
        extension: "",
        phone: "",
        mail: "",
        note: "",
      });
    };

    const changeValue = (type, index, value) => {
      console.log(type, index, value);
      switch (type) {
        case "companyName":
          const companyItem = addCompanyInformationTableItems.value[index];
          let companyParams = {};
          companyParams["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          companyParams["user"] = loginData.value.account;
          companyParams["vuePage"] = "devicemanagement";
          companyParams["methods"] = "POST";
          companyParams["whichFunction"] = "CheckCompanyChangeValue";
          companyParams["companyName"] = companyItem.companyName;
          methods.axiosAction(companyParams).then(() => {
            let result = axiosResult.value;
            if (result["Response"] != "ok") {
              methods.setTimeoutAlert("此名稱已新增");
              addCompanyInformationTableItems.value[index]["companyName"] = "";
            }
          });
          break;
        case "contactPerson":
          // const contactItem = addEquipmentVendorTableItems.value[index];
          // if (contactItem.orgContactPerson === contactItem.contactPerson) {
          //   return;
          // }
          // let contactParams = {};
          // contactParams["webPage"] =
          //   sideNavPath.value.length != 0
          //     ? sideNavPath.value[sideNavPath.value.length - 1]
          //     : null;
          // contactParams["user"] = loginData.value.account;
          // contactParams["vuePage"] = "devicemanagement";
          // contactParams["methods"] = "POST";
          // contactParams["whichFunction"] = "CheckCompanyChangeValue";
          // contactParams["contactPerson"] = contactItem.contactPerson;
          // contactParams["replenish"] =
          //   addCompanyInformationTableItems.value[0].companyName;
          // methods.axiosAction(contactParams).then(() => {
          //   let result = axiosResult.value;
          //   if (result["Response"] != "ok") {
          //     methods.setTimeoutAlert("此名稱已新增");
          //     const newContactPerson =
          //       contactItem.newContactPerson !== undefined
          //         ? contactItem.newContactPerson
          //         : contactItem.orgContactPerson;

          //     addEquipmentVendorTableItems.value[index]["contactPerson"] =
          //       newContactPerson;
          //   } else {
          //     contactItem.newContactPerson = contactItem.contactPerson;
          //   }
          // });
          break;

        default:
          break;
      }
    };

    const commonMethods = {
      queryFirmInfo: queryFirmInfo,
      companyRowClick: companyRowClick,
      addCompany: addCompany,
      addCompanyCheck: addCompanyCheck,
      modCompany: modCompany,
      modCompanyCancel: modCompanyCancel,
      modCompanyCheck: modCompanyCheck,
      back: back,
      addContactPerson: addContactPerson,
      changeValue: changeValue,
    };

    provide("firm", firm);
    provide("add", add);
    provide("mod", mod);
    provide("manufacInfoTableFields", manufacInfoTableFields);
    provide("manufacInfoTableItems", manufacInfoTableItems);
    provide("companyInformationTableFields", companyInformationTableFields);
    provide("companyInformationTableItems", companyInformationTableItems);
    provide("addCompanyInformationTableItems", addCompanyInformationTableItems);
    provide("equipmentVendorTableFields", equipmentVendorTableFields);
    provide("equipmentVendorTableItems", equipmentVendorTableItems);
    provide("addEquipmentVendorTableItems", addEquipmentVendorTableItems);
    provide("commonMethods", commonMethods);
    return {
      detail,
      add,
      mod,
      back,
      companyRowClick,
      addCompany,
      modCompany,
      modCompanyCancel,
      modCompanyCheck,
    };
  },
};
</script>

<style></style>
